import { FETCH_LOCATION_CATEGORY_PRODUCTS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_LOCATION_CATEGORY_PRODUCTS:
      return { ...state, [action.parent_id]: action.payload }
    default:
      return state
  }
}
